import { Navigate } from 'react-router-dom';
import { useContext } from "react";
import UserContext from "../context/UserContext.js";
import { auth } from '../firebase/config.js';

const ProtectedRoute = ({ children, redirectTo }) => {
  const {user, LSuser} = useContext(UserContext);

  return LSuser ? (
    children
  ) : (
    <Navigate to={redirectTo}/>
  );
};

export default ProtectedRoute;